import { useCallback, MouseEvent } from 'react';

import { Service } from '@app-types/service.type';

import { ServiceItem } from '../../components/service-item/service-item';

import styles from './service-list.module.scss';

type Props = {
    services: Service[];
    onCreatePlan: (serviceId: number) => void;
    onEditPlan: (planId: number) => void;
    onEditService: (serviceId: number) => void;
    onDeletePlan: (planId: number) => void;
};

const ServiceList = ({
    services,
    onCreatePlan,
    onEditPlan,
    onEditService,
    onDeletePlan,
}: Props) => {
    // This way ensures to handle clicks avoids managing several click events for each plan
    // and reduce memory usage in the web app
    const listenPlanActions = useCallback(
        (ev: MouseEvent) => {
            const target = ev.target as HTMLElement;
            const element = target.closest(
                '[data-action]'
            ) as HTMLElement | null;
            if (!element) return;

            switch (element.dataset.action) {
                case 'edit-plan':
                    return onEditPlan(Number(element.dataset.id));
                case 'delete-plan':
                    return onDeletePlan(Number(element.dataset.id));
                default:
                    return;
            }
        },
        [onEditPlan, onDeletePlan]
    );

    return (
        <div className={styles.list} onClick={listenPlanActions}>
            {services.map((service) => (
                <ServiceItem
                    key={service.id}
                    service={service}
                    onCreatePlan={onCreatePlan}
                    onEdit={onEditService}
                />
            ))}
        </div>
    );
};

export { ServiceList };
